import { PureComponent } from "react";

import {
    DiscussionLinkCompact,
    type IDiscussionLinkResponse,
} from "commonComponents/utilities/Discussions/DiscussionLinkCompact";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

class DiscussionCell extends PureComponent<IGridCellRenderProps<IDiscussionLinkResponse>> {
    render() {
        const { cellValue } = this.props;
        return cellValue ? (
            <DiscussionLinkCompact
                id={cellValue.id}
                entityType={cellValue.entityType}
                builderId={cellValue.builderId}
                jobId={cellValue.jobId}
                commentCount={cellValue.commentCount}
                unreadCommentCount={cellValue.unreadCommentCount}
                onClick={cellValue.onClick}
                doNotNavigate={cellValue.doNotNavigate}
            />
        ) : null;
    }
}

export const columnDiscussion: IClientGridColumn<IDiscussionLinkResponse> = {
    columnType: GridColumnType.discussion,
    Cell: DiscussionCell,
};
